<template>
  <div class="width-medium mx-auto">
    <f-button
      theme="primary"
      :disabled="actionInProgress || !message || !message.length || !adviser.phone"
      @click="sendTestSMS">
      {{ $t('communicationSms.sendTestSms') }}
    </f-button>
    <div class="card is-smallshadow mt-2 mb-2">
      <div class="card-body px-3 pt-3">
        <h2 class="heading-small" v-pure-html="$t('communicationSms.sendTestSmsText')"></h2>

        <validation-observer
          ref="communication-sms-form"
          tag="form">
          <div class="form-group mb-0">
            <label for="message">{{ $t('messageForm.writeTheMessage') }}: </label>

            <validation-provider
              rules="required|max:9000"
              name="message"
              v-slot="{ errors }">
              <f-textarea
                v-model="message"
                :maxLength="200"
                :showCounter="true"
                :rows="4"
                :state="errors.length ? 'invalid' : null"/>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </div>
    </div>

    <div class="card is-smallshadow mt-2 mb-3">
      <div class="card-body px-3 pt-3">
        <div class="flex flex-align-items-center">
          <h2 class="heading-small">{{ $t('communicationSms.recipients') }}</h2>
          <div class="ml-auto small">{{ $t('communicationSms.customersChoose.choose') }} {{ receivers.length }} {{ $t('communicationSms.customersChoose.customers') }}</div>
        </div>

        <v-select
          v-if="!allCustomersSelected"
          :options="allAvailableCustomers"
          v-model="receivers"
          :reduce="(customer) => customer.id"
          :multiple="true"
          :placeholder="$t('communicationMail.selectRecipients')"
          label="name"
          class="mb-4-sm">
          <template
            slot="option"
            slot-scope="option">
            {{ option.name }} {{ option.surname }}
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            {{ option.name }} {{ option.surname }}
          </template>
        </v-select>

        <div class="flex flex-align-items-center flex-wrap flex-justify-content-between">
          <f-checkbox
            class="block mt-1 mr-5"
            v-model="allCustomersSelected"
            @change="selectAllCustomers()">
            {{ $t('communicationSms.sendForAll') }}
          </f-checkbox>

          <f-button
            v-if="!allCustomersSelected"
            class="mt-1 px-0"
            theme="text-alert"
            @click.prevent="emptyReceiversList">
            {{ $t('communicationSms.deselectAll') }}
          </f-button>
        </div>
      </div>
    </div>

    <div class="buttins-wrapper text-right">
      <f-button
        class="ml-auto"
        :disabled="actionInProgress || !message || !message.length || !receivers.length"
        theme="primary"
        withArrow
        big
        @click.prevent="validateForm">
        {{ $t('communicationSms.messageSend') }}
      </f-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'communication-sms-form',
  props: {
    allAvailableCustomers: {
      type: Array,
      default: () => []
    },
    adviser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      message: '',
      receivers: [],
      allCustomersSelected: false,
      actionInProgress: false
    };
  },
  mounted () {
  },
  methods: {
    submitForm () {
      this.actionInProgress = true;
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/api/adviser/communications/sms/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('registerMailSent.sendMessage'),
        successText: this.$t('communicationSms.messageSendTo.messageSendToCustomer'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('communicationSms.messageSendTo.messageSendToCustomerError'),
        successAction: () => {
          this.actionInProgress = false;
          this.clearForm()
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    sendTestSMS () {
      this.actionInProgress = true;
      let formDataToSend = {
        phone: this.adviser.phone,
        message: this.message
      };

      FormUtils.submit(this, {
        endpoint: '/api/adviser/communications/sms/send-test',
        formData: formDataToSend,
        successTitle: this.$t('communicationSms.messageSmsSendTo.messageSmsSendToCustomer'),
        successText: this.$t('communicationSms.messageSmsSendTo.messageSuccessSend'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('communicationSms.messageSmsSendTo.messageSmsSendToCustomerError'),
        successAction: () => {
          this.actionInProgress = false;
          this.clearForm()
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['communication-sms-form'], this.submitForm);
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        message: this.message,
        receivers: this.receivers
      };

      return formDataToSend;
    },
    clearForm() {
      this.message = '';
      this.receivers = [];
      this.$refs['communication-sms-form'].reset();
    },
    selectAllCustomers () {
      Vue.nextTick(() => {
        Vue.set(this, 'receivers', this.allAvailableCustomers.map(item => item.id));
      })
    },
    emptyReceiversList () {
      Vue.set(this, 'receivers', []);
    }
  }
};
</script>
